'use client';

import type { ReactNode } from 'react';
import type { SerializedAuthSession } from '@/lib/auth/session-serialization';
import type { AuthSession } from '@/types/auth';
import { BaseProviders } from './providers/base';

export function Providers({
  children,
  initialSession,
}: {
  children: ReactNode;
  initialSession?: AuthSession | SerializedAuthSession | null | undefined;
}) {
  return <BaseProviders initialSession={initialSession}>{children}</BaseProviders>;
}
